module.exports = __webpack_public_path__ + "img/more_comm.7c282269.png";